<template>
    <div name="soldoc-function" class="soldoc-function">
        <div class="soldoc-function-inner">
            <h3>원장님은 진료만 보세요<br>나머지는 솔닥이 할게요</h3>
            <p>기존 EMR은 그대로 사용하시고<br>온라인에서 설치 없이 간편한 솔닥파트너스를 추가 활용해보세요</p>
            <div class="card-area">
                <div class="card-item">
                    <div class="img-area">
                        <img class="mouse-arrow" src="../../assets/partners_pc/img_soldoc_function1.png" alt="">
                    </div>
                    <strong>병원 홍보</strong>
                    <ul>
                        <li>홍보물 무상 지급</li>
                        <li>마케팅 맞춤 솔루션</li>
                    </ul>
                </div>
                <div class="card-item">
                    <div class="img-area">
                        <img class="mouse-arrow" src="../../assets/partners_pc/img_soldoc_function2.png" alt="">
                    </div>
                    <strong>CS</strong>
                    <ul>
                        <li>솔닥 전담 CS팀에서 고객 응대</li>
                        <li>의료진 전담 고객센터 운영</li>
                    </ul>
                </div>
                <div class="card-item">
                    <div class="img-area">
                        <img class="mouse-arrow" src="../../assets/partners_pc/img_soldoc_function3.png" alt="">
                    </div>
                    <strong>물류</strong>
                    <ul>
                        <li>병원 의료기기 재고 부담 없는 시스템</li>
                        <li>주문 접수부터 발송까지, 솔닥에서 전담</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-function",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-function-inner").offset().top;
            var aniTitle = $(".soldoc-function-inner h3");
            var aniText = $(".soldoc-function-inner > p");
            var aniItem = $(".soldoc-function-inner .card-area");

            if (height <= 0) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniText).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1000) {
                $(aniTitle).removeClass('item-hide').addClass('item-show');
                $(aniText).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1000) {
                $(aniTitle).removeClass('item-show').addClass('item-hide');
                $(aniText).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-function {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 994px;
    background: #EBF7FE;
}
.soldoc-function .soldoc-function-inner {    
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1240px;
    padding: 127px 20px 164px;
}
.soldoc-function-inner h3 {
    min-height: 123px;
    margin-bottom: 0;
    font-size: 46px;
    font-weight: 600;
    line-height: 60px;
    color: #000;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-function-inner p {
    margin-top: 32px;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #1A1A1A;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-function-inner .card-area {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 114px;
    visibility: hidden;
    opacity: 0;
}
.soldoc-function-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-function-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-function .soldoc-function-inner .card-item {
    width: 378px;
    height: 378px;
    border-radius: 20px;
    background: #FFF;
    overflow: hidden
}
.soldoc-function .soldoc-function-inner .card-item .img-area {
    width: 100%;
    height: 200px;
    padding-top: 42px;
    border-radius: 20px 20px 0px 0px;   
}
.soldoc-function .soldoc-function-inner .card-item:first-child .img-area {
    padding-left: 132px;
    background: #008DEF;
}
.soldoc-function .soldoc-function-inner .card-item:nth-child(2) .img-area {
    padding-left: 121px;
    background: #A3D8FF;
}
.soldoc-function .soldoc-function-inner .card-item:last-child .img-area {
    padding-top: 24px;
    padding-left: 109px;
    background: #003153;
}
.soldoc-function .soldoc-function-inner .card-item strong {
    display: block;
    margin-top: 30px;
    margin-left: 35px;
    font-size: 26px;
    font-weight: 600;
    line-height: 36px;
    color: #000;
}
.soldoc-function .soldoc-function-inner .card-item ul {
    list-style: none;
    margin: 10px 0 0 35px;
    padding: 0 0 0 28px;
}
.soldoc-function .soldoc-function-inner .card-item ul li {
    position: relative;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    color: #1A1A1A;
}
.soldoc-function .soldoc-function-inner .card-item ul li::before {
    content: '';
    position: absolute;
    top: calc(50% - 2px);
    left: -16px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #1A1A1A;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/SoldocFunction.vue